import { IoWarningOutline } from "react-icons/io5";
import ReactModal from "react-modal";
import styles from "./css/CustomModel.module.scss";

const CustomModal = ({ isOpen, onRequestClose, onConfirm }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <div className={`${styles.modalContent}`}>
        <div>
          <IoWarningOutline />
        </div>
        <p>Are you really want to delete this ?</p>
        <div className={`${styles.modalActions}`}>
          <button onClick={onConfirm}>Delete</button>
          <button onClick={onRequestClose}>Cancel</button>
        </div>
      </div>
    </ReactModal>
  );
};

export default CustomModal;
